/**
 * groupByEntityId
 * This function groups the id of an entity by the id of another entity,
 * returning an object that has the second entity's IDs as keys and an array
 * of the related first entity's IDs as values.
 * For example, given an array of credits, it will return an object of credit
 * ids grouped by instance id.
 *
 * @param  {Array}      responseArray   the array of items to be grouped
 * @param  {String}     [entityIdKey]   the id property of the entity to use as the key in byId
 * @param  {String}     [idKey='id']    the id property of the item that will be grouped in
 *                                      the resulting arrays
 * @return {Object}                     the object of entity ids as keys and arrays of item ids as
 *                                      values
 */
export default (responseArray, entityIdKey, idKey = 'id') =>
  responseArray.reduce((result, item) => {
    const entityId = item[entityIdKey];
    const id = item[idKey];
    const existingEntity = result[entityId];

    const existingArray = existingEntity || [];

    return {
      ...result,
      ...(entityId &&
        id && {
          [entityId]: [...existingArray, `${id}`]
        })
    };
  }, {});
